declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Record<string, string>;
  }
}

export function getRuntimeEnv(key: string): string | undefined {
  const runtimeValue = window.__RUNTIME_CONFIG__?.[key];
  if (runtimeValue !== undefined && runtimeValue !== '') {
    return runtimeValue;
  }

  return process.env[key];
}
